<template>
  <div class="prepeers-mbti-chip">
    <span class="prepeers-mbti-chip__code">{{ props.code }}</span>
    <span
      v-if="props.subtitle"
      class="prepeers-mbti-chip__sep"
      >:</span
    >
    <span
      v-if="props.subtitle"
      class="prepeers-mbti-chip__subtitle"
      >{{ props.subtitle }}</span
    >
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

const props = defineProps({
  code: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String as PropType<string | undefined>,
    default: undefined,
  },
})
</script>

<style scoped>
.prepeers-mbti-chip {
  display: inline-flex;
  align-items: baseline;
  gap: var(--space-2);
  font-family: var(--font-display);
  font-size: var(--text-xl);
  font-weight: 800;
  color: var(--accent-blue-lt);
  background: rgba(3, 160, 241, 0.12);
  border: 1.5px solid rgba(3, 160, 241, 0.25);
  border-radius: var(--radius-md);
  padding: var(--space-1) var(--space-3);
  line-height: 1.4;
}

.prepeers-mbti-chip__code {
  letter-spacing: var(--tracking-wide);
}

.prepeers-mbti-chip__sep {
  font-weight: 600;
  opacity: 0.7;
}

.prepeers-mbti-chip__subtitle {
  font-weight: 500;
  font-family: var(--font-body);
  font-size: var(--text-base);
  color: var(--text-primary);
}
</style>
